import { map } from 'lodash/fp';
import { stringifyShortcut } from './utils';
import { ShortcutKey, CUSTOM_LINK_KEYS } from './constants';

export const MODULE_NAME = 'shortcuts';

export const TIMELINE_SHORTCUT = stringifyShortcut(ShortcutKey.TimeLine);
export const RESERVATION_OVERVIEW_SHORTCUT = stringifyShortcut(ShortcutKey.ReservationOverview);
export const DASHBOARD_SHORTCUT = stringifyShortcut(ShortcutKey.Dashboard);
export const NEW_RESERVATION_SCREEN_SHORTCUT = stringifyShortcut(ShortcutKey.NewReservationScreen);
export const RESOURCE_STATUS_REPORT_SHORTCUT = stringifyShortcut(ShortcutKey.ResourceStatusReport);
export const CUSTOM_LINKS_SHORTCUTS = map((key: ShortcutKey) => stringifyShortcut(key))(CUSTOM_LINK_KEYS);

export const getCustomLinkShortcutTooltipOnIndex = (index: number) => CUSTOM_LINKS_SHORTCUTS[index] || '';
